import {backAdmin} from "../axios";

export const walletsApi = [
    {url: `${backAdmin}/wallet`, name: 'wallets.all', method: 'GET'},
    {url: `${backAdmin}/wallet/history`, name: 'wallets.history', method: 'GET'},
]